export default __webpack_public_path__ + "static/media/insulation_2.1e11139f.JPG";